import store, { SIDENAV_CLASSES } from '@/store'
import { saveRedirectPath } from '@/services/redirectAfterLogin'
import { leaveApp, lockedLocation, redirectLocation } from './navigation'

export const DOMAIN_TOP = 'top'
export const DOMAIN_WORKSPACE = 'workspace'
export const DOMAIN_ANY = 'any'

export const WorkspaceStatuses = {
  inProgress: -1,
  inactive: 0,
  unverified: 1,
  active: 10
}

// the whole page goes to the other domain; returns whether it went
const redirectToTopDomain = (to) => {
  leaveApp(`https://${store.getters.frontDomain}${to.fullPath}`)
  return true
}

const redirectToWorkspaceDomain = (to) => {
  const userDomain = store.state.auth.user.domain
  if (!userDomain) return false
  leaveApp(`https://${userDomain}.${store.getters.frontDomain}${to.fullPath}`)
  return true
}

const checkDomain = (requiredDomain) => {
  if (requiredDomain === DOMAIN_ANY) {
    return { redirectRequired: false }
  }

  const workspaceDomain = store.getters.workspaceDomain
  if (requiredDomain === DOMAIN_TOP) {
    return { redirectRequired: workspaceDomain !== '', target: DOMAIN_TOP }
  }

  if (requiredDomain === DOMAIN_WORKSPACE) {
    return { redirectRequired: workspaceDomain === '', target: DOMAIN_WORKSPACE }
  }

  throw new Error(`Unknown required domain type ${requiredDomain}`)
}

function isLoginRoute(routeName) {
  return (routeName || '').startsWith('login')
}

export const handleRoute = async (to, from, _next) => {
  // every redirect below goes through redirectLocation: on a page load or back / forward the
  // address being stopped is already in the history and must be replaced, not pushed over
  const next = (location) => (location && typeof location === 'object' ? _next(redirectLocation(to, location)) : _next(location))

  await store.dispatch('auth/restoreUserBeforeRouting')
  const signed = store.getters['auth/isUserSigned']

  // process requireSigned
  if (to.meta.requireSigned !== undefined) {
    if (!signed && to.meta.requireSigned) {
      if (!isLoginRoute(to.name)) {
        saveRedirectPath(to.fullPath)
        next({ name: 'login' })
      } else {
        next()
      }
      return
    } else if (signed && !to.meta.requireSigned) {
      to.name !== 'home' ? next({ name: 'home' }) : next()
      return
    }
  }

  // process requireDomain
  if (to && to.meta.requireDomain !== undefined) {
    const { redirectRequired, target } = checkDomain(to.meta.requireDomain)
    if (redirectRequired) {
      if (target === DOMAIN_WORKSPACE && !signed) {
        next({ name: 'login' })
        return
      }
      const left = target === DOMAIN_WORKSPACE ? redirectToWorkspaceDomain(to) : redirectToTopDomain(to)
      if (left) {
        // the browser is on its way to the other domain: rendering the screen here meanwhile
        // would only flash it (and fire its requests against the wrong workspace)
        next(false)
        return
      }
    } else if (target === DOMAIN_WORKSPACE) {
      const workspaceStatus = await store.dispatch('loadWorkspaceStatus')
      if (workspaceStatus.status === 'error') {
        const nativeStatus = workspaceStatus.errors.status
        switch (nativeStatus) {
          case WorkspaceStatuses.inProgress:
          case WorkspaceStatuses.unverified:
            next({ name: 'register-verification' })
            return
          case WorkspaceStatuses.inactive:
            next(lockedLocation(to.path))
            return
        }
      }
    }
  }

  // close sidenav on route change
  if (store.state.sidenavClass === SIDENAV_CLASSES.expanded) {
    await store.dispatch('setSidenavClass', '')
  }

  next()
}
